import FieldUser from "../../../../fields3/generic/user/user"
import FieldConfig from "../../../proto/field-config"
import UserManager from "../../../../manager/user-manager/user-manager"
import FieldTimeReportUser_TableCell from "./render/table/table-cell"
import FieldTimeReportUser_TableCellCalculated from "./render/table/table-cell-calculated"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types";

export default class FieldTimeReportUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.label              = "Reported by"
        this.description        = "Choose the user for whom this report will be submitted. Manager access is required to submit on behalf of another user."
        this.noValueOption      = false

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldTimeReportUser_TableCell
        this.renderComponents.tableCellCalculated   = FieldTimeReportUser_TableCellCalculated
    }

    // access(model:any): 'read' | 'write' | false {
    //
    //     if (_.has(model,'systemStatus')) {
    //         if (!gd.const.systemStatus.isOpen(model.systemStatus)) return 'read'
    //     }
    //
    //     if (_.has(model,'projectId')) {
    //         // ARE you sure about it ? seems like not a good deal - check canChangeAr - this is task model
    //         if (!gd.ac.check.project.fullAccess(model.projectId)) return 'read'
    //     }
    //
    //     return 'write'
    // }

    getOptionsForEdit(model:any) {

        const userManager = new UserManager()
        const managerIds = userManager.getManagerForUsersIds();

        // the server only lets a meeting participant report, so narrow the list to participants
        const editableIds = model?.meeting
            ? _.intersection(managerIds, model.meeting.usersIds)
            : managerIds

        return _.map(editableIds, (userId:ID)=>{

            const user = gd.session.users.get(userId)!

            return {
                value: user.id,
                label: user.name
            }
        })

    }

    getDefaultAggregateFunction(): AggregateFunctionType {
        return AggregateFunctionType.USERS_UNION
    }
}
